import { FCOCard } from '@tecton/ComponentRedesign';
import moment from 'moment-timezone';
import { FC } from 'react';
import { AnyFCO, FCOFields } from '../../../core/types/fcoTypes';
import { Avatar, Badge, FlexGroup, FlexItem, Text } from '@lithos';
import { dateTimeFormat, timeZone } from '@lithos/DateUtils';

interface FCOMetadataCardProps {
  fco: AnyFCO;
}

const FCOMetadataCard: FC<FCOMetadataCardProps> = ({ fco }) => {
  const items = [
    {
      title: <>ID</>,
      content: <Text code>{fco[FCOFields.ID]}</Text>,
    },

    {
      title: <>Owner</>,
      content:
        fco[FCOFields.OWNER] === 'n/a' ? (
          <>-</>
        ) : (
          <FlexGroup padding="0" direction="row" gapSize="2" alignItems="center">
            <FlexItem grow="0" shrink="0">
              <Avatar name={fco.owner} />
            </FlexItem>
            <FlexItem grow="0" shrink="0">
              <Text>{fco.owner}</Text>
            </FlexItem>
          </FlexGroup>
        ),
    },
    {
      title: <>Created</>,
      content: dateTimeFormat(moment(fco[FCOFields.CREATED_DATE]).toDate(), timeZone.UTC),
    },
    {
      title: <>Last Updated By</>,
      content: fco[FCOFields.LAST_MODIFIED_BY] && (
        <FlexGroup padding="0" direction="row" gapSize="2" alignItems="center">
          <FlexItem grow="0" shrink="0">
            <Avatar name={fco[FCOFields.LAST_MODIFIED_BY]} />
          </FlexItem>
          <FlexItem grow="0" shrink="0">
            <Text>{fco[FCOFields.LAST_MODIFIED_BY]}</Text>
          </FlexItem>
        </FlexGroup>
      ),
    },
    {
      title: <>Last Updated</>,
      content: dateTimeFormat(moment(fco[FCOFields.LAST_MODIFIED_DATE]).toDate(), timeZone.UTC),
    },
    {
      title: <>Defined In</>,
      content: <Text code>{fco[FCOFields.SOURCE_FILE_NAME]}</Text>,
    },
    {
      title: <>Prevent Destroy</>,
      content: (
        <Badge
          label={fco[FCOFields.PREVENT_DESTROY] ? 'Enabled' : 'Disabled'}
          size="s"
          color={fco[FCOFields.PREVENT_DESTROY] ? 'blueMist' : 'gray'}
        />
      ),
    },
  ];

  return <FCOCard title="Metadata" items={items} data-testid="fco-metadata-card" />;
};

export default FCOMetadataCard;
